import React from "react"
import styled from "styled-components"
import { fontSize, fontWeight } from "buoy-theme"
import { ButtonLink } from "buoy-core"
import Arrow from "../images/Arrow"
import { CardSection } from "./Card"
import Text from "../../common/components/Text"
import { CardLabel } from "../../common/components/Label"
import { sectionActionTracker } from "../actions"

const ArrowContainer = styled.div`
  width: 100%;
  margin-top: 6px;
`

const ExpandArrow = styled(Arrow)`
  display: inline-flex;
  margin: 0 8px;
  vertical-align: middle;
`

const Header = styled.h2`
  ${fontSize("h3")};
  font-weight: ${fontWeight.regular};
  margin: 0 auto 4px;
`
const Note = styled.p`
  ${fontSize("bodySmall")};
  font-weight: ${fontWeight.regular};
  padding: 0;
  margin: 0 auto 8px;
`

const ExpandLink = styled(ButtonLink).attrs({
  fontSize: "bodyMain",
})`
  display: inline-block;
  margin-top: 6px;
`

const ExpandableSection = ({
  excerpt,
  title,
  header,
  note,
  label,
  expanded,
  children,
  toggleExpanded,
  expandable,
  showPreview,
  expandLink,
  collapseLink,
  ...props
}) => {
  return (
    <CardSection onClick={toggleExpanded} {...props}>
      {label && <CardLabel margin="0 0 10px">{label}</CardLabel>}
      {header && <Header>{header}</Header>}
      {note && <Note>{note}</Note>}

      {showPreview && !expanded ? (
        <Text>{excerpt ? excerpt : children}</Text>
      ) : expandable && expanded ? (
        children
      ) : null}

      {expandable && (
        <ArrowContainer {...props}>
          <ExpandLink onClick={toggleExpanded}>
            {expanded ? collapseLink : expandLink}
            <ExpandArrow
              color="primary"
              rotation={expanded ? "180deg" : 0}
              width="14"
              height="7"
            />
          </ExpandLink>
        </ArrowContainer>
      )}
    </CardSection>
  )
}

class ExpandableSectionContainer extends React.Component {
  state = {
    expanded: false,
  }

  toggleExpanded = e => {
    // prevent duplicate execution when ExpandLink clicked
    e.stopPropagation()

    if (this.props.type) {
      const section_title = `diagnosis match ${this.props.index+1}`
      let action
      if (this.state.expanded) {
        action = `collapse-${this.props.type}`
      } else {
        action = `expand-${this.props.type}`
      }
      sectionActionTracker(section_title, action)
    }
    this.setState({
      expanded: !this.state.expanded,
    })
  }

  render() {
    let { expandable } = this.props

    return (
      <ExpandableSection
        {...this.props}
        {...this.state}
        toggleExpanded={expandable ? this.toggleExpanded : null}
      />
    )
  }
}

ExpandableSectionContainer.defaultProps = {
  showPreview: true,
  expandable: true,
  expandLink: "Read more",
  collapseLink: "Read less",
  excerpt: null,
}

export { ExpandableSectionContainer as default, ExpandableSection }



// WEBPACK FOOTER //
// ./assets/completion/components/ExpandableSection.js